import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { chatbotToolsApi } from '@/lib/api/chatbot-tools.api';

import type {
  ChatbotToolImportDto,
  ChatbotToolQuery,
  CreateChatbotToolDto,
  TestChatbotToolDto,
  UpdateChatbotToolDto,
} from '@repo/shared-types';

const KEY = ['chatbot-tools'];

export function useChatbotTools(query?: ChatbotToolQuery) {
  return useQuery({
    queryKey: [...KEY, query],
    queryFn: () => chatbotToolsApi.getAll(query),
  });
}

export function useCreateChatbotTool() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateChatbotToolDto) => chatbotToolsApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useUpdateChatbotTool() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateChatbotToolDto }) =>
      chatbotToolsApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useDeleteChatbotTool() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => chatbotToolsApi.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useTestChatbotTool() {
  return useMutation({
    mutationFn: (data: TestChatbotToolDto) => chatbotToolsApi.test(data),
  });
}

export function useImportChatbotTools() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: ChatbotToolImportDto) => chatbotToolsApi.import(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
